<template>
  <div>
    <page-header title="地址列表" />
    <div class="container">
      <div class="list-container">
        <div class="address-item" v-for="(item, index) in addressList" :key="index">
          <div class="radio" v-if="type">
            <custom-radio
              :checked="item.addressId == defaultAddress.addressId"
              @onChange="onCheckAddress(item)"
            ></custom-radio>
          </div>
          <div class="user-info">
            <div class="name">
              <div class="man">{{ item.man }}</div>
              <div class="man label" v-if="item.defaultFlag == '1'">默认</div>
            </div>
            <div class="phone">{{ item.phone }}</div>
            <div class="phone">{{ item.area }} {{ item.address }}</div>
          </div>
          <div class="btn-container">
            <router-link
              :to="{
                name: 'create-address',
                query: {
                  addressId: item.addressId,
                  provinceId: item.provinceId,
                  cityId: item.cityId,
                  address: item.address,
                  man: item.man,
                  phone: item.phone,
                  defaultFlag: item.defaultFlag,
                },
              }"
              >编辑</router-link
            >
            <div @click="deleteAddress(item.addressId)">删除</div>
          </div>
        </div>
      </div>

      <div class="create-address-btn-container">
        <router-link :to="{ name: 'create-address' }">
          <div class="primary-button">新增收货地址</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/header.vue';
import CustomRadio from '@/components/custom-radio.vue';
import User from '@/api/user';
import { Dialog, Toast } from 'vant';

import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      addressList: [],

      // true 选择地址
      type: this.$route.query.type,
    };
  },

  computed: {
    ...mapState(['defaultAddress']),
  },

  created() {
    this.type = this.$route.query.type;
    this.loadAddressList();
  },

  methods: {
    ...mapMutations(['setDefaultAddress']),
    async loadAddressList() {
      try {
        const { data: res } = await User.loadAddressList({});
        if (res.code == 0) {
          this.addressList = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    deleteAddress(addressId) {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该地址吗?',
      })
        .then(() => {
          this.handleDelete(addressId);
        })
        .catch(() => {
          // on cancel
        });
    },

    async handleDelete(addressId) {
      try {
        const { data: res } = await User.deleteAddress({
          addressId,
        });
        if (res.code == 0) {
          Toast.success('删除成功');
          setTimeout(() => {
            this.loadAddressList();
          }, 1000);
        }
      } catch (e) {
        console.log(e);
      }
    },

    onCheckAddress(item) {
      this.setDefaultAddress(item);
      this.$router.back();
    },
  },
  components: {
    PageHeader,
    CustomRadio,
  },
};
</script>
<style scoped lang="sass" src="./index.sass"></style>
